import React from 'react';

import PDPGallery from './pdp-gallery';
import Offers from './above-the-fold-offers';
import TitleSection from './title-section';
import Specs from './specs-section';
import CartSection from './cart-section';
import './pdp-details.less'

export default ({ }) => {
    return (<div className='pdp-details' id='pdpOverview'>
        <div className='image-section'>
            <PDPGallery />
            <Offers showFor={['desktop', 'tablet']} />
        </div>
        <div className='hero-section'>
            <TitleSection />
            <Specs />
            <CartSection />
        </div>
    </div>);
}